export default __webpack_public_path__ + "static/media/stack_logos-mongodb.965e1323.png";